import type { ComponentPropsWithoutRef, ReactElement } from 'react'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import cn from 'classnames'
import styles from './FavoriteToggleButton.module.css'

interface FavoriteToggleButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'children'> {
  isFavourite: boolean
}

export function FavoriteToggleButton({
  className,
  isFavourite,
  type = 'button',
  ...props
}: FavoriteToggleButtonProps): ReactElement {
  return (
    <button
      {...props}
      className={cn(styles.button, className)}
      type={type}
    >
      <Icon
        className={cn(styles.icon, isFavourite ? styles.iconFavorite : styles.iconNotFavorite)}
        glyph={isFavourite ? 'HeartFilled' : 'Heart'}
        size={24}
      />
    </button>
  )
}
